import { UserForm } from "./UserPage";
export function CreateUserPage() {
    return <UserForm userId={null} isNew={undefined} changePasswordDialogControls={undefined}/>;
}
